<template>

  <div class="wrapper">
    <button-action :title="title" :active="active"></button-action>
    <input type="file" @change="chooseFile" :accept="accept" :multiple="multiple" :disabled="!active">
  </div>

</template>

<script>
// FOR USE IN (BROWSER) ONLY
import ButtonAction from '../buttons/ButtonAction.vue';

export default {
  name: 'button-file',
  props:{
    title:{default:"no title prop set."},
    active:{
      type:Boolean,
      default:true
    },
    accept:{
      default:"*"
    },
    multiple:{
      type:Boolean,
      default:false,
    }
  },
  data:function(){
    return {
    }
  },
  methods:{
    chooseFile(e){
      
      if(!this.active){
        // prevent button events on further bubble
        return;
      }
      
      this.$emit('change',e);

      // reset value to trigger @change for same file choosen
      e.target.value="";
    }
  },
  computed:{
  },
  mounted:function(){
    
  },
  components:{
    ButtonAction
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon{
  flex:1;
  text-align:right;
}
.wrapper{
  position:relative;
  
}
input{
  cursor:pointer;
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  opacity:0;
}
</style>
